import axios from "axios";

var APIURL = process.env.REACT_APP_API_ENDPOINT;
//APIURL = "https://api-pi-public.azurewebsites.net/";

const axiosCall = axios.create({
  baseURL: APIURL,
  headers: {
    "Content-type": "application/json",
  },
});

// Add a response interceptor
axiosCall.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if(error.response.status === 401) {
      window.location.href = process.env.REACT_APP_SITE_PATH!
    }

    return Promise.reject(error);
  }
);

axiosCall.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default axiosCall;
